module.exports = __webpack_public_path__ + "static/media/logo_login.2e0cd2ef.png";